import { render, staticRenderFns } from "./SiteSettingPassword.vue?vue&type=template&id=f6527160&scoped=true&"
import script from "./SiteSettingPassword.vue?vue&type=script&lang=js&"
export * from "./SiteSettingPassword.vue?vue&type=script&lang=js&"
import style0 from "./SiteSettingPassword.vue?vue&type=style&index=0&id=f6527160&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6527160",
  null
  
)

export default component.exports